/**
 * ASCII-safe slug for a download name: diacritics folded ("Müller" →
 * "muller"), everything but a–z / 0–9 collapsed to single dashes. A name in a
 * non-Latin script folds to "" — the caller then falls back.
 */
export function fileNameSlug(value: string | null | undefined): string {
  return (value ?? "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40)
    .replace(/-+$/g, "");
}

/** Local calendar day, `YYYY-MM-DD` — the day the operator downloaded it. */
function localDay(now: Date): string {
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/**
 * `<prefix>-<last>-<first>-<YYYY-MM-DD>.json`. A guest without a usable name
 * is named by id, so two exports never share a name by accident; a prefix
 * that folds to nothing (non-Latin locale) becomes `guest-data`.
 */
export function guestDataExportFileName(
  prefix: string,
  guest: { guestId: string; firstName?: string | null; lastName?: string | null },
  now: Date = new Date(),
): string {
  const name = [fileNameSlug(guest.lastName), fileNameSlug(guest.firstName)].filter(Boolean).join("-");
  const who = name || fileNameSlug(guest.guestId) || "guest";
  return `${fileNameSlug(prefix) || "guest-data"}-${who}-${localDay(now)}.json`;
}
